import { Injectable } from '@angular/core';
import { OccCheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/occ';
import { HttpClient } from '@angular/common/http';
import {
    ConverterService,
    OccEndpointsService,
    UserIdService,
} from '@spartacus/core';

@Injectable({
    providedIn: 'root',
})
export class SikoOccCheckoutPaymentTypeAdapter extends OccCheckoutPaymentTypeAdapter {

    private userId?: string;

    constructor(
        protected http: HttpClient,
        protected occEndpoints: OccEndpointsService,
        protected converter: ConverterService,
        protected userIdService: UserIdService,
    ) {
        super(http, occEndpoints, converter);
    }

    protected getPaymentTypesEndpoint(): string {
        this.userIdService.getUserId().subscribe(
            (occUserId: string) => this.userId = occUserId,
        )
            .unsubscribe();

        return this.occEndpoints.buildUrl('paymentTypes', {
            urlParams: { userId: this.userId },
        });
    }

}
